import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TriangleArrowUpIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M1.40329 22.0489L14.415 7.73212C15.3095 6.74788 16.8092 6.75751 17.691 7.75317L30.5178 22.236C31.4815 23.3242 30.7389 25.0949 29.3226 25.0858L2.56188 24.9138C1.14546 24.9047 0.425698 23.1247 1.40329 22.0489Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
